import { ViewGridIcon } from "@heroicons/react/outline";

const ProgramIcon = ViewGridIcon;

export default ProgramIcon;
